import request from '../../helpers/request';
import { SCOOTER_MAINTENANCE_URL } from 'constants/api';

export const getScooterMaintenance = (params: any): Promise<string> =>
    request.get(SCOOTER_MAINTENANCE_URL, { params });
